<template>
  <div class="switcher" :class="{ 'text-left': isTextLeft }">
    <div
      class="switcher__item"
      :class="{ checked: value, disabled: disabled, loading: loading }"
      @click="$emit('input', !value)"
    >
      <div class="point"></div>
    </div>

    <div v-if="text" class="switcher__label" @click="$emit('input', !value)">{{ text }}</div>
  </div>
</template>

<script>
  export default {
    name: 'Switcher',

    props: {
      value: {
        type: Boolean,
        default: false,
        required: true
      },

      disabled: {
        type: Boolean,
        default: false
      },

      loading: {
        type: Boolean,
        default: false
      },

      text: {
        type: String,
        default: ''
      },

      isTextLeft: {
        type: Boolean,
        default: false
      }
    }
  };
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.switcher {
  display: flex;
  flex-direction: row;
  align-items: center;

  &.text-left {
    display: inline-flex;
    flex-direction: row-reverse;

    .switcher__label {
      margin-left: 0;
      margin-right: 12px;
    }
  }

  &__item {
    display: flex;
    border-radius: 13px;
    min-width: 46px;
    max-width: 46px;
    min-height: 24px;
    max-height: 24px;
    background-color: #7f7f7f;
    cursor: pointer;
    align-items: center;
    transition: background-color 0.15s;

    .point {
      background-color: #fff;
      min-width: 20px;
      max-width: 20px;
      min-height: 20px;
      max-height: 20px;
      border-radius: 10px;
      border: 2px solid #7f7f7f;
      margin-left: 3px;
      transition: border-color 0.15s;
    }

    &.checked {
      background-color: $green;
      justify-content: flex-end;
      transition: background-color 0.15s;

      .point {
        margin-right: 3px;
        border-color: $green;
        transition: border-color 0.15s;
      }
    }

    &.loading {
      justify-content: center;
      opacity: 0.6;
      pointer-events: none;
    }

    &.disabled {
      opacity: 0.6;
      pointer-events: none;
    }
  }

  &__label {
    margin-left: 12px;
    font-size: 15px;
    color: #333;
    cursor: pointer;
  }
}
</style>
